export class LoginRequestModel {
    userId!: string;
    password!: string;
    captchaRes!: string;
    loginOtp!: string;
}
